export const phoneFormatInput = {
	format: "+7 ### ###-##-##",
	mask: "_",
};
export const minutesSecondsFormatInput = {
	format: "##:##",
};
export const phoneCodeFormatInput = {
	format: "####",
};
